<template>
  <div class="warehousingRecord-section">
    <div class="page-title">{{$t('warehousingAudit.warehousingRecord')}}</div>
    <ul class="corpus-tab">
      <li v-for="item in corpusTabList" :key="item.code" class="corpus-tab_btn"
          :class="`corpus-tab_${item.code} ${corpusActive===item.code?'corpus-tab-active':''}`"
          @click="handleChangeCorpusTab(item)">
        {{item.name}}
      </li>
    </ul>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in tableTabList" :key="item.name" :name="item.name" lazy>
        <div slot="label" class="slot-tab">
          <span class="label">{{item.label}}</span>
          <span class="count">{{item.count}}</span>
        </div>
        <warehous-audit-tab-table v-if="activeName===item.name" :corpusType="corpusType"
                                  :corpusActive="corpusActive" :activeName="activeName"
                                  :countRecordsInfo="countRecordsInfo"
                                  :selectOptions="selectOptions"
                                  @updateCurrentCount="updateCurrentCount">
        </warehous-audit-tab-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { countRecordsV2, queryCriteria } from '../../../services/warehousingAudit';
import WarehousAuditTabTable from '../components/warehousAuditTabTable.vue';
export default {
  name: 'WarehousingRecord',
  components: {
    WarehousAuditTabTable
  },
  data () {
    return {
      corpusActive: 'memory',
      corpusTabList: [
        { name: this.$t('newProjectV2.transMemoryBank'), code: 'memory' },
        { name: this.$t('newProjectV2.termBank'), code: 'term' }
      ],
      activeName: 'first',
      tableTabList: [
        { label: this.$t('warehousingAudit.inStorage'), name: 'first', code: 'receivedCount', count: 0 },
        { label: this.$t('warehousingAudit.underReview'), name: 'second', code: 'underReviewCount', count: 0 },
        { label: this.$t('managementV2.returned'), name: 'third', code: 'failPassCount', count: 0 },
        { label: this.$t('managementV2.canceled'), name: 'fourth', code: 'cancelCount', count: 0 },
      ],
      countRecordsInfo: {},
      selectOptions: {}
    }
  },
  computed: {
    /**
     * @desc 语料类型转化 string(this.corpusActive)=>number(1|2)
     * @return {Number} 返回 (1|2)
     */
    corpusType () {
      const obj = {
        memory: 1,
        term: 2
      }
      return obj[this.corpusActive]
    },
  },
  mounted () {
    this.getCountRecords()
    this.getQueryCriteria()
  },
  methods: {
    handleChangeCorpusTab (data) {
      if (data.code === this.corpusActive) return
      this.corpusActive = data.code
      this.activeName = 'first'
      this.getCountRecords()
      this.getQueryCriteria()
    },

    handleClick (tab) {
      const name = tab.paneName
    },

    async getCountRecords () {
      const params = {
        corpusType: this.corpusType
      }
      const { result, success } = await countRecordsV2(params)
      if (!success) return
      this.countRecordsInfo = result
      this.tableTabList.forEach(item => {
        item.count = result[item.code]
      })
    },
    async getQueryCriteria () {
      const params = {
        corpusType: this.corpusType
      }
      const { result, success } = await queryCriteria(params)
      if (!success) return
      this.selectOptions = result
    },
    updateCurrentCount () {
      this.getCountRecords()
      this.getQueryCriteria()
    }
  },
}
</script>

<style lang="less" scoped>
@import "./assets/style/index.less";
</style>